<template>
  <div class="mm-button" :loading="loading">
    <el-popover placement="bottom-end" trigger="hover">
      <div class="spaceLeft">
        <img class="mm-logo" src="../../../assets/logo/mm-logo.png" />
        <account class="mm-text" v-if="account" :value="account" />
        <el-button type="text" v-else class="mm-text" @click="connectMetaMask">{{ btnText }}</el-button>
      </div>
      <div slot="reference">
        <img class="asset-img" v-if="btnText == 'Connected'" src="@/assets/image/login/assetLogin.svg" />
        <img class="asset-img" v-else src="@/assets/image/login/assetLogout.svg" />
      </div>
    </el-popover>
  </div>
</template>

<script>
import MetaMaskOnboarding from "@metamask/onboarding";
import metaMask from "./metaMask.js";
import { CheckAccount } from "@/layout/components/metaMaskInit/accountHandler.js"

import { setChainId, getChainId } from "@/utils/auth.js"
export default {
  data() {
    return {
      isInstall: true,
      isConnect: false,
      btnText: "Install MetaMask",
      loading: false,
      isLog: true,
      account: undefined,
    };
  },
  methods: {
    async init() {

      return new Promise((reslove) => {
        this.isInstall = metaMask.isMetaMaskInstalled();
        this.$store.commit("app/SET_MATEMASK", { isInstall: this.isInstall });
        if (this.isInstall) {
          this.connectMetaMask(reslove);
        } else {
          reslove("not install");
        }
      });
    },
    connectMetaMask(reslove) {
      if (this.isConnect) {
        return;
      }
      if (!this.isInstall) {
        // window.open("https://metamask.io/download/")
        this.loading = true;
        this.btnText = "Onboarding in progress";
        const onboarding = new MetaMaskOnboarding();
        onboarding.startOnboarding();
        reslove();
      } else {
        this.loading = false;
        this.btnText = "Connect Wallet";
        this.onClickConnect(reslove);
      }
    },
    async onClickConnect(reslove) {
      try {
        // Will open the MetaMask UI
        // You should disable this button while the request is pending!
        this.loading = true;
        await ethereum.request({ method: "eth_requestAccounts" });
        const accounts = await ethereum.request({ method: "eth_accounts" });
        console.log(`"accounts=",${accounts}`);
        if (!accounts[0]) {
          this.$message.error("Not able to get accounts");
        } else {
          this.account = accounts[0];
          this.btnText = "Connected";
          this.isConnect = true;
          this.$store.commit("app/SET_MATEMASK", {
            isConnect: true,
            account: accounts[0],
          });
        }
        reslove();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$store.commit("app/SET_MATEMASK", { isConnect: false });
        console.log(error);
        reslove();
      }
    },
    async joinNet() {
      try {
        console.log('process.env.VUE_APP_CHAINID', process.env.VUE_APP_CHAINID);
        try {
          // 先尝试切换到指定链
          await ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: process.env.VUE_APP_CHAINID }],
          });
        } catch (err) {
          // 如果错误代码为4902，表示该链未添加到MetaMask
          if (err.code === 4902) {
            console.log('未添加的网络，尝试添加...');
            console.log('process.env.VUE_APP_RPC_URLS', JSON.parse(process.env.VUE_APP_RPC_URLS));
            await ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: process.env.VUE_APP_CHAINID, //死的 可以写到配置文件里面
                  chainName: "Treasurenet", // 就是一个名字随便起
                  rpcUrls: JSON.parse(process.env.VUE_APP_RPC_URLS),
                  nativeCurrency: {
                    name: "UNIT",
                    symbol: "UNIT", // 2-6 characters long
                    decimals: 18,
                  },
                },
              ],
            });
          } else {
            // 其他错误直接抛出
            throw err;
          }
        }
        console.log("joinNet ok===");
        this.$store.commit("app/SET_MATEMASK", { isJoinNet: true });
      } catch (error) {
        this.loading = false;
        this.$store.commit("app/SET_MATEMASK", { isJoinNet: false });
        console.log('joinNetError;', error);
      }
    },
  },
  created() {
    this.init().then((res) => {
      console.log("initok---");
      this.joinNet();
      this.$store.commit("app/SET_MATEMASK", { initOk: true });
      ethereum.autoRefreshOnNetworkChange = false;
      CheckAccount();
      //监听钱包切换
      const self = this
      ethereum.on("accountsChanged", function (accounts) {
        // window.location.reload();
        self.$store.dispatch("LogOut").then(() => {
          location.reload();
        });
      });
      //监听链网络改变
      ethereum.on("chainChanged", (chainId) => {
        sessionStorage.setItem("TREASURE_CHAINID", chainId);
        if (this.$store.getters.metaMaskObj.stopRefreshJoinNet) {
          this.$store.commit("app/SET_MATEMASK", { chainId: chainId });
          if (chainId != process.env.VUE_APP_CHAINID) {
            this.$message.error("connection failed! ");
          }
        } else {
          window.location.reload();
        }
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.mm-button {
  display: inline-block;
  background: transparent;
  cursor: pointer;
  color: #1f1f1f;
  margin: 0 0.32rem 0 0;

  .asset-img {
    height: 0.19rem;
    position: relative;
    top: 0.01rem;
  }
}

.mm-logo {
  height: 0.26rem;
  margin-right: 0.16rem;
  position: relative;
  top: 0.03rem;
}

.mm-text {
  position: relative;
  top: 0.02rem;
}
</style>
